var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedListButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 11.6665C5.33301 11.3904 5.55687 11.1665 5.83301 11.1665H14.833C15.1091 11.1665 15.333 11.3904 15.333 11.6665C15.333 11.9426 15.1091 12.1665 14.833 12.1665H5.83301C5.55687 12.1665 5.33301 11.9426 5.33301 11.6665Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 7.6665C5.33301 7.39036 5.55687 7.1665 5.83301 7.1665H14.833C15.1091 7.1665 15.333 7.39036 15.333 7.6665C15.333 7.94265 15.1091 8.1665 14.833 8.1665H5.83301C5.55687 8.1665 5.33301 7.94265 5.33301 7.6665Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 3.6665C5.33301 3.39036 5.55687 3.1665 5.83301 3.1665H14.833C15.1091 3.1665 15.333 3.39036 15.333 3.6665C15.333 3.94265 15.1091 4.1665 14.833 4.1665H5.83301C5.55687 4.1665 5.33301 3.94265 5.33301 3.6665Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 4.6665C2.88529 4.6665 3.33301 4.21879 3.33301 3.6665C3.33301 3.11422 2.88529 2.6665 2.33301 2.6665C1.78072 2.6665 1.33301 3.11422 1.33301 3.6665C1.33301 4.21879 1.78072 4.6665 2.33301 4.6665Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 8.6665C2.88529 8.6665 3.33301 8.21879 3.33301 7.6665C3.33301 7.11422 2.88529 6.6665 2.33301 6.6665C1.78072 6.6665 1.33301 7.11422 1.33301 7.6665C1.33301 8.21879 1.78072 8.6665 2.33301 8.6665Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 12.6665C2.88529 12.6665 3.33301 12.2188 3.33301 11.6665C3.33301 11.1142 2.88529 10.6665 2.33301 10.6665C1.78072 10.6665 1.33301 11.1142 1.33301 11.6665C1.33301 12.2188 1.78072 12.6665 2.33301 12.6665Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedListButton);
export default __webpack_public_path__ + "static/media/unorderedListButton.d1266a635fc0dfad75ac29028af1dc6a.svg";
export { ForwardRef as ReactComponent };